export const formatStringIntoDutchPostalCode = (input: string): string => {
    // the user is typing, so we don't want to format it yet
    if (input.length <= 5) {
        return input;
    }

    // Basic pattern: 4 digits + 2 letters, possibly with whitespace
    const basicFormat = /^\s*\d{4}\s*[a-zA-Z]{2}\s*$/;

    // If it doesn't resemble a postal code, return trimmed input
    if (!basicFormat.test(input)) {
        return input.trim();
    }

    const trimmed = input.trim();
    const uppercased = trimmed.toUpperCase();
    const compacted = uppercased.replace(/\s+/g, '');

    // Strict Dutch postal code: 1000–9999 + two letters, excluding SA/SD/SS
    const strictDutchFormat = /^[1-9]\d{3}(?!SA|SD|SS)[A-Z]{2}$/;
    const spacedFormat = `${compacted.slice(0, 4)} ${compacted.slice(4)}`;
    const isValid = strictDutchFormat.test(compacted);

    return isValid ? spacedFormat.toUpperCase() : trimmed;
};
